import * as React from 'react';
import { Heading, Stack, Text } from '@origin-digital/ods-core';

export const PlanKeyDetailsModal = (
  <Stack data-id="plan-key-details-info-modal">
    <Heading variant="h3">About energy rates</Heading>
    <Stack space="xxsmall">
      <Text weight="medium">Variable rates</Text>
      <Text>
        A variable rate means what you pay for energy could go up or down. Origin may change prices
        – we'll always let you know. We consider all kinds of factors when setting and changing our
        prices, like changes in our costs and conditions in the energy market overall.
      </Text>
    </Stack>
    <Stack space="xxsmall">
      <Text weight="medium">Fixed rates</Text>
      <Text>
        A fixed (or guaranteed) rate won’t change over your energy plan period. The rates you sign
        up for today won’t change for 12 months.
      </Text>
    </Stack>
  </Stack>
);
